import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export const Header = ({ event }) => {
  return (
    <header className="absolute top-0 left-0 right-0 z-40 px-4 sm:px-6 py-5 flex items-center justify-between">
      <Link to="/" data-testid="header-logo-link">
        <Logo className="text-lg sm:text-xl" />
      </Link>
      <div className="flex items-center gap-3">
        <span className="hidden sm:block font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-400">
          {event.city}
        </span>
        <a
          href={event.ticketUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="header-get-tickets-btn"
          className="border border-acid text-acid font-display font-bold uppercase tracking-wide text-xs sm:text-sm px-4 sm:px-5 py-2 hover:bg-acid hover:text-black transition-colors duration-300"
        >
          Get Tickets
        </a>
      </div>
    </header>
  );
};
